import styled from 'styled-components';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { H5 } from '../../base/typography';

export const Wrapper = styled.div`
	height: 100%;
	background-color: #fff;
	box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.1);
	transition: box-shadow 200ms;

	&:hover {
		box-shadow: 0px 14px 34px rgba(0, 0, 0, 0.15);
	}
`;

export const BoxImage = styled(DynamicRspImage)`
	padding-top: 58%;
`;

export const BoxContent = styled.div`
	padding: 6rem;
`;

export const BoxTitle = styled(H5)``;
